import { useMediaQuery, useTheme } from '@material-ui/core';
import { Link, useHistory, useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import useApi from '../../../utils/useApi';
import CostsNew from '../New/costsNew';
import CostsSearch from '../Search/costsSearch';

const CostsShow = () => {
  // verificar se é mobile e constantes para versão mobile
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));
  const location = useLocation();
  const history = useHistory();

  const [collapseNew, setCollapseNew] = useState(false);
  const [collapseSearch, setCollapseSearch] = useState(true);

  const [suppliersLoadSelect, suppliersInfo] = useApi({
    method: 'get',
    url: '/suppliers',
  });

  useEffect(() => {
    if (location.pathname.includes('/cadastrar')) {
      setCollapseNew(true);
      setCollapseSearch(false);
    } else {
      setCollapseNew(false);
      setCollapseSearch(true);
    }
  }, [location.pathname]);

  function changeCollapseSearch() {
    if (collapseSearch) {
      // Se está aberto e vai fechar (ir para novo), ou se apenas fecha?
      // A lógica original alternava. Se search fecha, new abre.
      history.push('/home/gestao/custos/cadastrar');
    } else {
      history.push('/home/gestao/custos');
    }
  }

  function changeCollapseNew() {
    if (collapseNew) {
      // Se está em novo e vai fechar -> vai para busca
      history.push('/home/gestao/custos');
    } else {
      history.push('/home/gestao/custos/cadastrar');
    }
  }

  useEffect(() => {
    suppliersLoadSelect();
  }, []);

  return (
    <>
      <CostsNew
        collapseNew={collapseNew}
        changeCollapseNew={changeCollapseNew}
        suppliersInfo={suppliersInfo}
      />
      <CostsSearch
        mobile={mobile}
        collapseSearch={collapseSearch}
        changeCollapseSearch={changeCollapseSearch}
        suppliersInfo={suppliersInfo}
      />
    </>
  );
};

export default CostsShow;
